

















import { Component, Vue } from 'vue-property-decorator';
import UnsupportCheck from '@/components/UnsupportCheck.vue';
import MaintenanceCheck from '@/components/MaintenanceCheck.vue';
import CompleteCheck from '@/components/CompleteCheck.vue';
import ModalApiError from '@/components/ModalApiError.vue';
import ScreenOrientationTracker from '@/components/ScreenOrientationTracker.vue';
import ModalSimple from '@/components/ModalSimple.vue';
import { ScreenOrientation } from '../resources/enum/ScreenOrientation';

@Component({
  components: {
    UnsupportCheck,
    MaintenanceCheck,
    CompleteCheck,
    ModalApiError,
    ScreenOrientationTracker,
    ModalSimple
  }
})
export default class Root extends Vue {
  private onOrientationChanged(value: ScreenOrientation) {
    this.$store.commit('orientation/setOrientation', value);
  }

  get isOrientationErrorVisible(): boolean {
    if (this.$route.name === 'face-action-shooting') return false;
    return (this.$store.state.orientation.orientation as ScreenOrientation) === ScreenOrientation.Landscape;
  }

  public created(): void {
    if (this.$route.name === 'launch') {
      // 最初のページでは全ての情報をリセット
      this.$store.dispatch('clearState');
      // リクエストトークンを記録しておく
      this.$store.commit('auth/storeRequestURL', { requestURL: location.href });
      this.$store.commit('auth/storeRequestToken', { requestToken: this.$route.query.t || '' });
    } else {
      // 最初のページ以外では必要な情報を取得済みなはずなので、このタイミングで対応機種確認を行う
      // (最初の通信を行わないと対応機種の範囲側買わないので、最初のページでは通信後に確認)
      this.$store.dispatch('support/check');
    }

    // i18n 初期化処理
    this.$store.dispatch('i18n/setDefaultLocale');
  }
}
